var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 127.151,
    viewBox: "0 0 126 127.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_verified_svg__Group_3016",
    "data-name": "Group 3016",
    transform: "translate(-10299 7839.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email_verified_svg__Group_3014",
    "data-name": "Group 3014",
    transform: "translate(136 431.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email_verified_svg__Union_2",
    "data-name": "Union 2",
    d: "M0,127.151v-82H0L51.615,3.758a18.907,18.907,0,0,1,22.627,0l51.615,41.393H126v82Z",
    transform: "translate(10163 -8271.498)",
    fill: "#d8d7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "email_verified_svg__Rectangle_430",
    "data-name": "Rectangle 430",
    width: 77,
    height: 64,
    rx: 12,
    transform: "translate(10188 -8247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "email_verified_svg__Group_3012",
    "data-name": "Group 3012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email_verified_svg__Intersection_17",
    "data-name": "Intersection 17",
    d: "M33.629,5.238,0,62.928H82L48.371,5.238C46.336,1.746,43.668,0,41,0S35.664,1.746,33.629,5.238Z",
    transform: "translate(10225.929 -8144.347) rotate(-90)",
    fill: "#c6f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email_verified_svg__Intersection_15",
    "data-name": "Intersection 15",
    d: "M33.629,57.691,0,0H82L48.371,57.691c-2.035,3.492-4.7,5.238-7.371,5.238S35.664,61.183,33.629,57.691Z",
    transform: "translate(10163.071 -8144.347) rotate(-90)",
    fill: "#c6f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email_verified_svg__Intersection_16",
    "data-name": "Intersection 16",
    d: "M51.615,3.758,0,45.152H125.857L74.242,3.758a18.907,18.907,0,0,0-22.627,0Z",
    transform: "translate(10163 -8189.499)",
    fill: "#adf7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "email_verified_svg__Group_3013",
    "data-name": "Group 3013",
    transform: "translate(610.533 -1198.467)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "email_verified_svg__Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(9594.467 -7040.533)",
    fill: "#84ff88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email_verified_svg__Union_1",
    "data-name": "Union 1",
    d: "M7.447,21.647H0v-4.4H7.447V0h4.209V21.647Z",
    transform: "translate(9619.806 -7032.404) rotate(45)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email_verified.7b754658c2e0c2feefc781dce7826476.svg";
export { ForwardRef as ReactComponent };